import { request } from 'shared/lib/request';

export const fetchExcoInfoModalData = ({ companyId }) =>
  request.get(`/companies/${companyId}/pending-changes`);

export const fetchEmployeeExcoInfoModalData = ({ companyId, employeeId }) =>
  request.get(
    `/companies/${companyId}/employees/${employeeId}/pending-changes`
  );

export const finalizeExcoData = ({ month, year, comment, companyId }) =>
  request.post(`/companies/${companyId}/pending-changes`, {
    month,
    year,
    comment,
  });

export const finalizeExcoDataByEmployee = ({
  month,
  year,
  comment,
  companyId,
  employeeId,
}) =>
  request.post(
    `/companies/${companyId}/employees/${employeeId}/pending-changes`,
    {
      month,
      year,
      comment,
    }
  );

export const fetchCheckPendingChanges = ({ companyId, year, month }) =>
  request.get(`/companies/${companyId}/check-pending-changes`, {
    params: {
      year,
      month,
    },
  });
